<template>
  <div class="col-lg-6 col-md-12 col-xs-12 px-6 cat-school-rank">
    <CatProficiencyRank />
    <CatRankPolicy />
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  import CatProficiencyRank from './CatProficiencyRank';
  import CatRankPolicy from '../../cat-main/components/CatRankPolicy';

  export default {
    name: 'cat-domain-rank',

    components: {
      CatProficiencyRank,
      CatRankPolicy,
    },

    computed: {
      ...mapGetters({
        routeParams: 'getRouteParams',
        domainProficiencyRank: 'getDomainProficiencyRank',
        isParentUser: 'isParentUser',
        selectedChildId: 'getSelectedChildId',
      }),
    },

    methods: {
      ...mapActions([
        'fetchDomainProficiencyRank',
      ]),
    },

    beforeMount() {
      const filters = {};
      filters.domain_id = this.routeParams.domainId;
      if (this.isParentUser) {
        filters.child_id = this.selectedChildId;
      }
      this.fetchDomainProficiencyRank(filters);
    },
  };
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// CatDomainRank.vue?267d22c6